import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell, IconButton, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { Delete } from '@mui/icons-material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const EngineIntervalListItemComponent = ({ containerDispatcher, item, index, dictionaryScoringResponseColor, validation, isReadOnly }) => {
  const { t } = useTranslation();

  const onPropertyChanged = (property, propertyValue) => {
    containerDispatcher({
      type: 'OnEngineIntervalChanged',
      property,
      propertyValue,
      index
    });
  };

  const onDeleteInterval = () => {
    containerDispatcher({
      type: 'OnEngineIntervalDeleted',
      engineIntervalId: item.engineIntervalId,
      index
    });
  };

  return (
    <TableRow hover key={index}>
      <TableCell>
        <TextField
          isNumeric
          fullWidth
          value={item.startsWith || ''}
          decimalScale={4}
          onChange={event => onPropertyChanged('startsWith', event)}
          disabled={isReadOnly}
          error={!isValid(validation.startsWith)}
          helperText={getErrors(validation.startsWith)}
        />
      </TableCell>
      <TableCell>
        <TextField
          isNumeric
          fullWidth
          value={item.endsWith || ''}
          decimalScale={4}
          onChange={event => onPropertyChanged('endsWith', event)}
          disabled={isReadOnly}
          error={!isValid(validation.endsWith)}
          helperText={getErrors(validation.endsWith)}
        />
      </TableCell>
      <TableCell>
        <Autocomplete
          fullWidth
          isDisabled={isReadOnly}
          value={item.resultId}
          simpleValue
          options={dictionaryScoringResponseColor}
          onChange={event => onPropertyChanged('resultId', event)}
          error={!isValid(validation.resultId)}
          helperText={getErrors(validation.resultId)}
        />
      </TableCell>
      <TableCell align='right'>
        <Tooltip title={t('Tooltips.Delete')}>
          <span>
            <IconButton color='primary' onClick={onDeleteInterval} disabled={isReadOnly}>
              <Delete />
            </IconButton>
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

EngineIntervalListItemComponent.propTypes = {
  containerDispatcher: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  dictionaryScoringResponseColor: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  isReadOnly: PropTypes.bool,
  validation: PropTypes.object.isRequired
};
export default EngineIntervalListItemComponent;
